module.exports = __webpack_public_path__ + "static/2020-10-22-Prilog-RadioOK-5551d3528885d3f0fc747a5b3d4719ce.mp3";